<template>
  <div class="Layout">
    <header>
      <HeaderNav />
    </header>
    <main>
      <router-view />
    </main>
    <layout-footer />
  </div>
</template>
<script>
import HeaderNav from "@/components/header-nav";
import LayoutFooter from "@/components/layout-footer";
export default {
  name: "Layout",
  components: { HeaderNav, LayoutFooter },
};
</script>
<style lang="less">
@import "@/assets/style/layout.less";
.Layout {
  min-width: 1200px;
  min-height: 100vh;
  overflow: auto;
  background-color: @layout-bg-color;
  position: relative;
  & > header {
    width: 100%;
    height: @header-height;
    position: fixed;
    left: 0px;
    top: 0px;
    background-color: #ffffff;
    z-index: 10;
  }
  & > main {
    margin: @header-height auto 0;
    min-height: calc(100vh - @header-height - @footer-height);
  }
  & > footer {
    width: 100%;
    height: @footer-height;
    background-color: aqua;
    box-sizing: border-box;
  }
}
</style>
